import { fetchSideAddresses } from './sideAddresses';

/** Optional frontage refinement must not prevent selecting the clicked building. */
export async function fetchSideAddressesWithDeadline(
  center: Parameters<typeof fetchSideAddresses>[0],
  geometry: Parameters<typeof fetchSideAddresses>[1],
  token: string,
): Promise<Awaited<ReturnType<typeof fetchSideAddresses>>> {
  const controller = new AbortController();
  let deadline: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      fetchSideAddresses(center, geometry, token, controller.signal).catch(() => []),
      new Promise<Awaited<ReturnType<typeof fetchSideAddresses>>>((resolve) => {
        deadline = setTimeout(() => {
          controller.abort();
          resolve([]);
        }, 8000);
      }),
    ]);
  } finally {
    if (deadline !== undefined) clearTimeout(deadline);
  }
}
